// extracted by mini-css-extract-plugin
module.exports = {"blockTitle":"RichText_blockTitle__yA0lI","content":"RichText_content__3nHMM"};